import React, { useState } from 'react';
import { Text, View, TouchableOpacity, StyleSheet } from 'react-native';
import { DNABox, Icon, Iffy, luxColors, } from '@alucio/lux-ui';
import { SideBarMenuItem } from './Menu';
import { MeetingControlSelectedVideoDimensionEnum, useMeetingControls, } from '@alucio/video';
import SettingPopOverDialog from './SettingPopOverDialog';
const styles = StyleSheet.create({
    settingsMenuContainer: {
        flex: 1,
        flexDirection: 'column',
        alignSelf: 'flex-start',
        borderRadius: 4,
        borderWidth: 2,
        paddingBottom: 17,
        paddingLeft: 20,
        paddingRight: 20,
        borderColor: luxColors.contentPanelBackground.tertiary,
        backgroundColor: luxColors.contentPanelBackground.primary,
        width: 240,
    },
    settingsMenuOption: {
        flex: 1,
        flexDirection: 'row',
        marginTop: 17,
    },
    settingsMenuIcon: {
        width: 17,
        height: 17,
        color: luxColors.info.primary,
    },
    settingsMenuLabel: {
        color: luxColors.info.primary,
        fontSize: 16,
        marginLeft: 10,
    },
});
const MenuItem = (props) => {
    return (React.createElement(TouchableOpacity, { onPress: props.onPress },
        React.createElement(View, { style: styles.settingsMenuOption },
            React.createElement(Icon, { style: styles.settingsMenuIcon, name: props.icon }),
            React.createElement(Text, { style: styles.settingsMenuLabel }, props.text),
            React.createElement(Iffy, { is: props.isSelected },
                React.createElement(Icon, { style: [styles.settingsMenuIcon, { marginLeft: 24 }], name: "check" })))));
};
const PopOverVideoMenu = () => {
    const { currentVideoDimension, setCurrentVideoDimensionsHandler } = useMeetingControls();
    const [isDialogVisible, setIsDialogVisble] = useState(false);
    const dimensionHandler = (dimension) => {
        setIsDialogVisble(false);
        setCurrentVideoDimensionsHandler(dimension);
    };
    return (React.createElement(SettingPopOverDialog, { visible: isDialogVisible, onPress: () => setIsDialogVisble(!isDialogVisible), onClose: () => setIsDialogVisble(false) },
        React.createElement(SettingPopOverDialog.Anchor, null,
            React.createElement(DNABox, null,
                React.createElement(SideBarMenuItem, { menuOption: { icon: 'view-compact', id: 'view-compact', title: 'View' } }))),
        React.createElement(SettingPopOverDialog.Content, null,
            React.createElement(View, null,
                React.createElement(View, { style: styles.settingsMenuContainer },
                    React.createElement(MenuItem, { isSelected: currentVideoDimension === MeetingControlSelectedVideoDimensionEnum.STANDARD, text: "Standard Videos", icon: "image-size-select-large", onPress: () => dimensionHandler(MeetingControlSelectedVideoDimensionEnum.STANDARD) }),
                    React.createElement(MenuItem, { isSelected: currentVideoDimension === MeetingControlSelectedVideoDimensionEnum.SMALL, text: "Small Videos", icon: "image-size-select-small", onPress: () => dimensionHandler(MeetingControlSelectedVideoDimensionEnum.SMALL) }),
                    React.createElement(MenuItem, { isSelected: currentVideoDimension === MeetingControlSelectedVideoDimensionEnum.HIDE, text: "Hide Videos", icon: "image-off", onPress: () => dimensionHandler(MeetingControlSelectedVideoDimensionEnum.HIDE) }))))));
};
export default PopOverVideoMenu;
//# sourceMappingURL=VideoMenu.js.map